import { Component, Input, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OrderLog, PaginatedOrderLogs } from '../../../../../models/orderModel';
import { BackOfficeService } from '../../../../../services/backoffice.service';
import { CheckoutService } from '../../../../../services/checkout.service';
import { BackOffice24OrderLogDetailsComponent } from './back-office24-order-log-details/back-office24-order-log-details.component';

@Component({
  selector: 'app-back-office24-order-log',
  templateUrl: './back-office24-order-log.component.html',
  styleUrl: './back-office24-order-log.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class BackOffice24OrderLogComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() orderId: string;
  @Input() loadData: boolean;
  orderLogs: OrderLog[];
  dataSource: MatTableDataSource<OrderLog> = new MatTableDataSource<OrderLog>([]);
  total: number = 0;
  pageSize: number = 10;
  pageIndex: number = 0;

  displayedColumns: string[] = [
    'description',
    'created',
    'createdBy'
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  componentDestroyed$: Subject<boolean> = new Subject();

  constructor(
    public backOfficeService: BackOfficeService,
    public checkoutService: CheckoutService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<OrderLog>([]);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['loadData'] && changes['loadData'].currentValue) {
      this.loadOrderLogs();
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.paginator.page.subscribe(pageEvent => {
      this.loadOrderLogs(pageEvent.pageIndex, pageEvent.pageSize);
    });
  }

  loadOrderLogs(pageIndex: number = 0, pageSize: number = 10) {
    const page = pageIndex + 1;
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    this.backOfficeService
      .getOrderLogsPaginated(this.orderId, page, pageSize)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((response: any) => {
        const total = Number(response?.pagination?.total ?? response?.total ?? response?.data?.length ?? 0);
        this.total = total;
        this.dataSource.data = response.data || [];

        if (this.paginator) {
          this.paginator.length = total;
          this.paginator.pageIndex = pageIndex;
        }
      });
  }

  showDetails(orderLog: OrderLog) {
    this.dialog.open(BackOffice24OrderLogDetailsComponent, {
      // height: '1010px',
      width: '720px',
      hasBackdrop: true,
      data: orderLog
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  flatten(obj: any) {
    return Object.keys(obj).reduce((acc, current) => {
      const _key = `${current}`;
      const currentValue = obj[current];
      if (Array.isArray(currentValue) || Object(currentValue) === currentValue) {
        Object.assign(acc, this.flatten(currentValue));
      } else {
        acc[_key] = currentValue;
      }
      return acc;
    }, {});
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
